import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import AuthenticationContext from 'context/Authentication/AuthenticationContext';

export default function Logout() {

    const history = useHistory();

    const { authenticationSignOut, signOutState } = useContext(AuthenticationContext)

    useEffect(() => {
        async function signOut() {
            await authenticationSignOut();
        }
        signOut();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (signOutState.hasSuccess || signOutState.hasError) {
            history.push('/admin/dashboard/account/login');
        }
    }, [signOutState.hasSuccess, signOutState.hasError, history])

    return (
        <>
        {signOutState.loading && <div>Cargando...</div>}
        </>
    )
}
